import { RouteType } from "types/RouteType";
import { authRoutes } from "@intrasync/stores";
import legacyLoginRoute from "./legacyLoginRoute";
import homeRoutesList from "./home/homeRoutesList";
import dashboardRoutesList from "./dashboard/dashboardRoutesList";
import adminRoutesList from "./admin/adminRoutesList";
import administrationRoutesList from "./administration/administrationRoutesList";
import billingRoutesList from "./billing/billingRoutesList";
import clientsRoutesList from "./clients/clientsRoutesList";
import whiteboardRoutesList from "./whiteboard/whiteboardRoutesList";
import ticketsRoutesList from "./tickets/ticketsRoutesList";
import modulesRoutesList from "./modules/modulesRoutesList";
import devopsRoutesList from "./devops/devopsRoutesList";
import infrastructureRoutesList from "./infrastructure/infrastructureRoutesList";
import meetingIntelligenceRoutesList from "./meetingIntelligence/meetingIntelligenceRoutesList";
import aiRoutesList from "./ai/aiRoutesList";
import aiAgentRoutesList from "./aiAgent/aiAgentRoutesList";
import dataMapperRoutesList from "./dataMapper/dataMapperRoutesList";
import reportsRoutesList from "./reports/reportsRoutesList";
import settingsRoutesList from "./settings/settingsRoutesList";
import deviceRoutesList from "./device/deviceRoutesList";
// Global 404 route (hidden, requiresAuth, NOT admin-gated) — RouterStore falls
// back to it for unknown route names / unmatched URL paths.
import notFoundRoute from "components/NotFound/notFound.Route";
// Global "access denied" route — PermissionManager.handleAuthReroute lands
// here when an authenticated user hits a route they cannot access.
import unauthorizedRoute from "components/Unauthorized/unauthorized.Route";
import { generateServiceViewRoutes } from "./utils/ServiceViewRouteGenerator";
import serviceStores from "../serviceStoresConfig";
// Applied LAST, over the fully composed list: adds the per-user page-visibility
// rules to each route's `hidden`, so a hidden page leaves the nav and the page
// search instead of merely bouncing when clicked. Composes with billingGate
// rather than replacing it — see stores/pageVisibilityGate.ts.
import { hideDeniedRoutes } from "../stores/pageVisibilityGate";

// Generate dynamic service view routes
const serviceViewRoutes = generateServiceViewRoutes(serviceStores);

// The Login / External Auth routes come from the library, not an HQ fork.
// HQ used to carry its own copy whose Login onEnter checked `isSignedIn` on an
// untracked 2s setTimeout — so a returning user whose session restored during
// boot sat on the login form for two seconds before being redirected. The
// library route redirects the instant `isSignedIn` flips (a `when` torn down on
// exit) and hands the destination to AuthStore.completePostLoginNavigation.
// Same cast as the RootStore boundary: the two RouteTypes are deliberately
// different shapes (see rootStoreConfig.ts).
const libraryAuthRoutes = authRoutes as unknown as RouteType[];

const routesList: RouteType[] = [
  ...libraryAuthRoutes,
  legacyLoginRoute,
  ...deviceRoutesList,
  ...homeRoutesList,
  // The Developer Dashboard (the landing route, rootStoreConfig defaultRoute):
  // @intrasync/dashboard's route adapted for HQ — see views/dashboard/.
  ...dashboardRoutesList,
  ...adminRoutesList,
  ...administrationRoutesList,
  ...billingRoutesList,
  ...clientsRoutesList,
  ...whiteboardRoutesList,
  ...ticketsRoutesList,
  ...modulesRoutesList,
  ...devopsRoutesList,
  ...infrastructureRoutesList,
  ...meetingIntelligenceRoutesList,
  ...aiRoutesList,
  ...aiAgentRoutesList,
  ...dataMapperRoutesList,
  ...reportsRoutesList,
  ...settingsRoutesList,
  ...serviceViewRoutes, // Add generated service view routes
  unauthorizedRoute,
  notFoundRoute,
];

// Named rather than exported inline: an anonymous default export in a .tsx
// file trips react-refresh/only-export-components.
const visibleRoutesList = hideDeniedRoutes(routesList);

export default visibleRoutesList;
